const ENDPOINT = new Map();

ENDPOINT.set('get', '/teacher/coordinator/teachers');

export default ENDPOINT
